import { Link } from "react-router-dom";
import HeroSlideshow from "./hero/HeroSlideshow";
import HeroNavDots from "./hero/HeroNavDots";
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [images, setImages] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeroImages = async () => {
      try {
        console.log('Fetching hero images from Supabase storage...');
        const { data: files, error } = await supabase
          .storage
          .from('hero_images')
          .list('', {
            limit: 100,
            offset: 0,
            sortBy: { column: 'name', order: 'asc' },
          });

        if (error) {
          console.error('Error fetching hero images:', error);
          return;
        }

        console.log('Successfully fetched hero images:', files);

        if (!files || files.length === 0) {
          console.log('No hero images found in bucket');
          setLoading(false);
          return;
        }

        const imageUrls = await Promise.all(
          files
            .filter(file => file.name.match(/\.(jpg|jpeg|png|gif|webp)$/i))
            .map(async (file) => {
              const { data: { publicUrl } } = supabase
                .storage
                .from('hero_images')
                .getPublicUrl(file.name);
              console.log(`Generated public URL for ${file.name}:`, publicUrl);
              return publicUrl;
            })
        );

        console.log('Final hero image URLs:', imageUrls);
        setImages(imageUrls);
      } catch (error) {
        console.error('Unexpected error fetching hero images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchHeroImages();
  }, []);

  if (loading) {
    return (
      <section className="relative h-screen max-h-[800px] min-h-[600px] bg-neutral-900">
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="animate-pulse text-white">Loading...</div>
        </div>
      </section>
    );
  }

  return (
    <section className="relative h-screen max-h-[800px] min-h-[600px] bg-neutral-900 overflow-hidden">
      <HeroSlideshow images={images} interval={5000} />
      
      <div className="relative z-10 text-center text-white max-w-4xl mx-auto px-6 h-full flex flex-col items-center justify-center">
        <h1 className="text-5xl md:text-7xl font-display mb-6 animate-fadeIn opacity-0" 
            style={{animationDelay: '0.3s', animationFillMode: 'forwards'}}>
          Evolve You At
        </h1>
        <h2 className="text-4xl md:text-6xl font-display mb-8 animate-fadeIn opacity-0" 
            style={{animationDelay: '0.6s', animationFillMode: 'forwards'}}>
          EVOLUTIONS MEDSPA
        </h2>
        <p className="text-xl md:text-2xl mb-12 animate-fadeIn opacity-0 font-light" 
           style={{animationDelay: '0.9s', animationFillMode: 'forwards'}}>
          Hair Restoration • Facial Aesthetics • IV Bar
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a
            href="#services"
            className="inline-block bg-primary hover:bg-primary-light text-white px-8 py-3 rounded-full text-lg transition-all duration-300 animate-fadeIn opacity-0 hover:scale-105 hover:shadow-hover"
            style={{animationDelay: '1.2s', animationFillMode: 'forwards'}}
          >
            Explore Our Services
          </a>
          <Link
            to="/newsletter"
            className="inline-block bg-white/10 text-white px-8 py-3 rounded-full text-lg hover:bg-white/20 transition-all duration-300 animate-fadeIn opacity-0 hover:scale-105 hover:shadow-hover backdrop-blur-sm"
            style={{animationDelay: '1.5s', animationFillMode: 'forwards'}}
          >
            Join Newsletter
          </Link>
        </div>
      </div>

      <HeroNavDots 
        total={images.length} 
        current={currentSlide} 
        onSelect={setCurrentSlide} 
      />
    </section>
  );
};

export default Hero;